import { FC } from 'react'

import { Button, Props } from '../button'

export const SkeletonButton: FC<Props> = ({ ...props }) => <Button {...props} disabled={true}></Button>
